import { render, staticRenderFns } from "./eduPerson.vue?vue&type=template&id=25eb2f66&scoped=true&"
import script from "./eduPerson.vue?vue&type=script&lang=js&"
export * from "./eduPerson.vue?vue&type=script&lang=js&"
import style0 from "./eduPerson.vue?vue&type=style&index=0&id=25eb2f66&scoped=true&lang=css&"
import style1 from "./eduPerson.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eb2f66",
  null
  
)

export default component.exports